import { wcoxmlwebActions } from './actions';

const companyInitState = {
  companyWcoXmlData: null,
  loading: true,
  saving: false,
  exporting: false,
  error: null,
};

export function wcoxmlwebReducer(state = companyInitState, { type, payload }) {
  switch (type) {
    case wcoxmlwebActions.EXPORT_WCOXML_CONFIG:
      return {
        ...state,
        exporting: true,
      };
    case wcoxmlwebActions.EXPORT_WCOXML_CONFIG_SUCCESS:
      return {
        ...state,
        exporting: false,
      };
    case wcoxmlwebActions.EXPORT_WCOXML_CONFIG_FAIL:
      return {
        ...state,
        exporting: false,
        error: payload.error,
      };
    case wcoxmlwebActions.GET_WCOXML_WEB_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case wcoxmlwebActions.GET_WCOXML_WEB_DETAILS_SUCCESS:
      return {
        ...state,
        companyWcoXmlData: payload.data,
        loading: false,
      };
    case wcoxmlwebActions.GET_WCOXML_WEB_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload.error,
      };

    default:
      return state;
  }
}
